import { PORTRAIT_GENERATION_SECONDS } from '@/common/constants/generationEstimates';
import useGenerationCountdown from '@/common/hooks/useGenerationCountdown';
import { formatTranslation } from '@/common/utils/formatTranslation';
import { GeneratingCard, GeneratingStageSection } from '../studio.styles';
import StudioGenerationLoader from './StudioGenerationLoader';

const GeneratingStage = ({
	labels,
	onComplete,
	totalSeconds = PORTRAIT_GENERATION_SECONDS,
	timeRemainingKey = 'estimatedPhotoTimeRemaining',
}) => {
	const remainingSeconds = useGenerationCountdown(
		totalSeconds,
		true,
		onComplete,
	);
	const phaseLabels = [
		labels.generatingPhaseLook,
		labels.generatingPhasePersona,
		labels.generatingPhaseAwaken,
	];

	return (
		<GeneratingStageSection
			data-studio-panel="generating"
			aria-label={labels.creatingSoftie}
		>
			<GeneratingCard>
				<StudioGenerationLoader
					variant="card"
					title={labels.creatingSoftie}
					subtitle={labels.generatingHint}
					phaseLabels={phaseLabels}
					totalSeconds={totalSeconds}
					remainingSeconds={remainingSeconds}
					timeLabel={formatTranslation(labels[timeRemainingKey], {
						seconds: remainingSeconds,
					})}
				/>
			</GeneratingCard>
		</GeneratingStageSection>
	);
};

export default GeneratingStage;
